// extracted by mini-css-extract-plugin
export default {"botonVerificar":"NuevoItemFiltros_botonVerificar__+7ZWv","botonConfirmar":"NuevoItemFiltros_botonConfirmar__cHXnA"};